export default {
  canWrite(context) {
    const canWrite = context.accessRights && context.accessRights.write;
    return canWrite;
  },
  canRead(context) {
    const canRead = context.accessRights && context.accessRights.read;
    return canRead;
  },
  canDelete(context) {
    const canRead = context.accessRights && context.accessRights.delete;
    return canRead;
  }
};
